import React, { useState, useEffect } from 'react';
import { getToolsData } from './components/data/toolsData';
import { Auth } from '../core/utils/auth';
import { returnAppHref, redirectApp } from '../core/utils/app';
import HomeExtraSections from './components/HomeExtraSections';
import PoweredByIcons from './components/HomeRevamp/PoweredByIcons';
import DemoTab from './components/HomeRevamp/DemoTab';

const IndexHome2 = () => {
    const auth = Auth();
    const upid = auth?.user_pid ? `?upid=${auth.user_pid}` : '';
    const [activeCategory, ] = useState('popular');
    const [, setIsLoading] = useState(true);
    const toolsData = getToolsData(auth);
    const modifiedToolsData = toolsData.map(tool => ({
        ...tool,
        link: tool.link + upid,
      }));

    useEffect(() => {
        const timer = setTimeout(() => setIsLoading(false), 500);
        return () => clearTimeout(timer);
      }, []);
      const fnRedirectApp = (url) => {
        redirectApp(auth, url, true);
    };

      const fnReturnAppHref = (url) => {
        return returnAppHref(auth, url, true);
      };

  return (
    <>
      <div className="sm:px-4 justify-self-center max-w-430:pt-0 max-w-[1200px] mx-auto">
        <PoweredByIcons />
        <DemoTab />
      </div>

      <div className="bg-[#F9FCFC]">
        <div className="text-center mb-[50px] pt-[50px] max-w-6xl mx-auto px-4">
          <h1 className="lg:text-[48px] text-[32px] font-semibold">More from AI-PRO</h1>
          <p className="text-[#000000BF] text-[16px]">Discover the platforms, products, and innovations shaping the AI-PRO experience.</p>
        </div>
        <HomeExtraSections tools={modifiedToolsData} fnRedirectApp={fnRedirectApp} fnReturnAppHref={fnReturnAppHref} activeCategory={activeCategory} />
      </div>
    </>
  )
}

export default IndexHome2